@if (measuringPoints) {
  <div>
    <h5 translate="services.measuringPoints.title"></h5>
    <div class="d-table w-100">
      @for (measuringPoint of measuringPoints |
        slice: (pagination.page-1) * pagination.maxMeasuringPoints : pagination.page * pagination.maxMeasuringPoints; track measuringPoint) {
        <div class="d-table-row">
          <div class="d-table-cell">
            <p><strong>{{ measuringPoint['name' + crtLang.toUpperCase()] }}</strong></p>
          </div>
          <div class="d-table-cell">
                <span class="dot gray-border" [ngClass]="{
                        'green': measuringPoint.measuringPointUsageState === MeasuringPointUsageState.Free,
                        'red': measuringPoint.measuringPointUsageState === MeasuringPointUsageState.Error,
                        'yellow': measuringPoint.measuringPointUsageState === MeasuringPointUsageState.Busy,
                        'gray': measuringPoint.measuringPointUsageState === MeasuringPointUsageState.Unknown }"></span>
            {{ 'common.measuringPointUsageState.' + measuringPoint.measuringPointUsageState | translate }}
          </div>
          @if (isExploitant) {
            <div class="d-table-cell">
              <button class="btn btn-outline-secondary m-2"
                [disabled]="measuringPoint.measuringPointUsageState !== MeasuringPointUsageState.Free"
                title="{{ 'common.activate' | translate }}"
                (click)="activateMeasuringPoint.emit(measuringPoint.id)"
                translate="common.activate">
              </button>
            </div>
          }
        </div>
      }
    </div>
    <div class="mt-3">
      @if (measuringPoints.length > pagination.maxMeasuringPoints) {
        <ngb-pagination
          [(page)]="pagination.page"
          [pageSize]="pagination.maxMeasuringPoints"
        [collectionSize]="measuringPoints.length"></ngb-pagination>
      }
    </div>
    @if (measuringPoints.length < 1) {
      <div>
        <p translate="services.measuringPoints.noDataAvailable"></p>
      </div>
    }
  </div>
}
